// Verified Hurricane Isaias (AL092026) landfall facts and storm observations.
// Every figure is attributed. `preliminary: true` marks figures from NWS
// Mobile's preliminary reports (published via local media Oct 12, 2026) that
// remain subject to the office's final post-storm survey.

export const SOURCES = {
  nhcLandfall: {
    short: "NHC Update",
    label: "NHC Tropical Cyclone Update, 8:30 PM CDT Oct 9, 2026",
    url: "https://www.nhc.noaa.gov/archive/2026/al09/al092026.update.10100129.shtml",
  },
  nhcAdv12: {
    short: "NHC Adv. 12",
    label: "NHC Advisory 12, 10:00 AM CDT Oct 9, 2026",
    url: "https://www.nhc.noaa.gov/archive/2026/al09/al092026.public.012.shtml",
  },
  nwsTae: {
    short: "NWS Tallahassee",
    label: "NWS Tallahassee Post-Tropical Cyclone Report (PSH)",
    url: "https://www.weather.gov/media/tae/TropicalEventSummary/PSHTAE_2026AL09_Isaias_Summary.pdf",
  },
  nwsMob: {
    short: "NWS Mobile",
    label: "NWS Mobile Public Information Statement, Oct 12, 2026",
    url: "https://tgftp.nws.noaa.gov/data/raw/no/nous44.kmob.pns.mob.txt",
  },
  nwsMobPrelim: {
    short: "NWS Mobile (prelim.)",
    label: "NWS Mobile preliminary reports (via WDAM, Oct 12, 2026)",
    url: "https://www.wdam.com/2026/10/12/new-data-is-coming-in-aftermath-hurricane-isaias/",
  },
};

export const LANDFALL = {
  dateLabel: "October 9, 2026",
  isoDate: "2026-10-09",
  time: "about 8:30 PM CDT",
  location: "near Destin, Florida",
  category: "Category 2",
  sustainedWinds: "105 mph",
  pressure: "971 mb (28.67 in)",
  peakIntensity: "Category 3 with 120 mph sustained winds at 10:00 AM CDT on October 9, roughly 195 miles south of Pensacola",
  centerAtLandfall: "30.4°N 86.5°W — about 40 miles east of Pensacola and 50 miles WNW of Panama City",
  windField: "Hurricane-force winds extended up to 35 miles from the center; tropical-storm-force winds up to 205 miles",
  surgeForecast: "6 to 9 feet above ground from the Alabama/Florida line to Grayton Beach if peak surge coincided with high tide",
  warnings: "Hurricane Warning from Ocean Springs, MS to the Bay/Gulf County line, FL; Storm Surge Warning from the Mouth of the Mississippi River to the Suwannee River",
  postTropical: "Post-tropical over southern Alabama by the morning of October 10, 2026",
};

// Observations grouped by cluster so each hub shows the readings closest to it.
export const OBSERVATIONS = {
  Pensacola: [
    { metric: "Peak wind gust", value: "117 mph", place: "Oriole Beach (Santa Rosa County)", source: "nwsMobPrelim", preliminary: true },
    { metric: "Peak wind gust", value: "116 mph (91 mph sustained)", place: "WeatherFlow station near Santa Rosa Sound", source: "nhcLandfall" },
    { metric: "Peak wind gust", value: "105 mph", place: "Navarre", source: "nwsMobPrelim", preliminary: true },
    { metric: "Peak wind gust", value: "100 mph (63 mph sustained)", place: "WeatherSTEM station near Pensacola", source: "nhcLandfall" },
    { metric: "Peak wind gust", value: "92 mph", place: "Pensacola", source: "nwsMobPrelim", preliminary: true },
    { metric: "Rainfall", value: "5.13 in", place: "Navarre", source: "nwsMobPrelim", preliminary: true },
    { metric: "Rainfall", value: "2.20 in", place: "Gulf Breeze", source: "nwsMobPrelim", preliminary: true },
  ],
  Destin: [
    { metric: "Landfall", value: "Cat 2 · 105 mph · 971 mb", place: "near Destin", source: "nhcLandfall" },
    { metric: "Peak wind gust", value: "91 mph (59 mph sustained)", place: "Choctaw Beach (Walton County)", source: "nwsTae" },
    { metric: "Peak wind gust", value: "84 mph", place: "Fort Walton Beach", source: "nwsMobPrelim", preliminary: true },
    { metric: "Peak wind gust", value: "76 mph", place: "Destin", source: "nwsMobPrelim", preliminary: true },
    { metric: "Peak wind gust", value: "72 mph (52 mph sustained)", place: "Ed Walline Beach Access, Santa Rosa Beach", source: "nwsTae" },
    { metric: "Peak wind gust", value: "62 mph", place: "Miramar Beach", source: "nwsTae" },
    { metric: "Lowest pressure", value: "980.7 mb", place: "Miramar Beach", source: "nwsTae" },
    { metric: "Rainfall", value: "9.65 in", place: "Shalimar", source: "nwsMobPrelim", preliminary: true },
    { metric: "Rainfall", value: "9.60 in", place: "Valparaiso", source: "nwsMobPrelim", preliminary: true },
    { metric: "Rainfall", value: "12.47 in", place: "DeFuniak Springs (Walton County)", source: "nwsTae" },
    { metric: "Rainfall", value: "6.12 in", place: "Destin", source: "nwsMobPrelim", preliminary: true },
    { metric: "Storm surge", value: "5.59 ft above MHHW", place: "NOAA gauge, Panama City Beach Pier", source: "nwsTae" },
  ],
};

export const SURVEY_NOTE =
  "NWS Mobile, which covers Escambia, Santa Rosa, and Okaloosa counties, announced on October 12, 2026 that storm-surge and wind surveys were under way and that a final assessment would follow in a Public Information Statement. Figures marked preliminary are subject to that final report.";
